var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"title":_vm.$t('page_organization_add_menber'),"visible":_vm.visible},on:{"ok":function () { return _vm.save(); },"cancel":function () { return _vm.cancel(); }}},[_c('ml-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.dataSource,"rowSelection":{
      selectedRowKeys: _vm.selectedRowKeys,
      onChange: _vm.onSelectChange
    },"size":"small","rowKey":"id","pagination":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }